<template>
  <div class="container index">
    <v-subheader>Stored Data</v-subheader>
    <div class="ma-5">
      <pre v-if="storedData">{{ storedData }}</pre>
      <span v-else>No Data</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import env from '@/env';
import { parseQrPayload, ownerToken } from "@/utils/worksheetLabelQr.js";

export default {
  data: () => {
    return {
      storedData: null,
      companyName: env.VUE_APP_COMPANY_NAME
    };
  },
  mounted() {
    const data = this.$route.params.data;
    if (data) {
      this.storedData = data;
      
      this.processStoredData();
    }
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage"]),
    processStoredData(){
      const payload = parseQrPayload(this.storedData);
      if(!payload){
        console.log("Unknown business type")
        return;
      }

      // Both payloads reduce to the same one-letter owner, so a sticker
      // belonging to another company is still turned away.
      if(payload.owner != ownerToken(this.companyName)){
        console.info('Unknown company ' + payload.owner + ' owner detected...');
        return;
      }

      if(payload.businessType === 'Inventory'){
        this.redirectToInventory(payload.documentNumber);
        return;
      }
      this.redirectToWorksheet(payload.worksheetId, payload.entryId);
    },
    redirectToInventory(documentNumber){
      this.$router.replace({
        name: 'inventorySearch',
        query: {
          method: 'documentId',
          search: documentNumber,
          availableOnly: 'false',
          open: '1',
        },
      });
    },
    redirectToWorksheet(worksheetId, worksheetEntryId){
      this.$router.replace({ name: 'WorksheetScan', params: {id: worksheetId, entryId: worksheetEntryId} });
    }
  },
};
</script>

<style></style>
